import type {
  AdminRole,
  PermissionDefinition,
  RbacPermission,
} from '@digitaltattoo/types';
import { apiClient } from '../utils/api';

export interface RbacConfiguration {
  roles: readonly AdminRole[];
  permissions: readonly PermissionDefinition[];
  matrix: Record<AdminRole, RbacPermission[]>;
  defaults: Record<AdminRole, readonly RbacPermission[]>;
  immutableRoles: AdminRole[];
  editablePermissions: Record<AdminRole, RbacPermission[]>;
}

async function readData<T>(response: Response): Promise<T> {
  const body = await response.json();
  if (!response.ok || !body.success) {
    throw new Error(body.message || 'RBAC request failed');
  }
  return body.data as T;
}

export async function getMyPermissions(): Promise<{
  role: string;
  permissions: RbacPermission[];
}> {
  return readData(await apiClient('/api/admin/rbac/me'));
}

export async function getRbacConfiguration(): Promise<RbacConfiguration> {
  return readData(await apiClient('/api/admin/rbac'));
}

export async function updateRolePermissions(
  role: AdminRole,
  permissions: RbacPermission[],
): Promise<void> {
  await readData(
    await apiClient(`/api/admin/rbac/roles/${role}`, {
      method: 'PUT',
      body: JSON.stringify({ permissions }),
    }),
  );
}

export async function resetRolePermissions(role: AdminRole): Promise<void> {
  await readData(
    await apiClient(`/api/admin/rbac/roles/${role}/reset`, {
      method: 'POST',
    }),
  );
}
